import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';

import { enableES5 } from 'immer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
  SettingsProvider,
  i18nSetup,
  restoreSettings,
} from '@nsd/fe';
import { configureStore } from 'src/store';
import App from 'src/App';
import clarity from 'src/utils/clarity';

// Initialize Microsoft Clarity analytics
clarity.initialize();

enableES5();
const store = configureStore();
const settings = restoreSettings();
i18nSetup();

ReactDOM.render(
  <Provider store={store}>
    <SettingsProvider settings={settings}>
      <App />
    </SettingsProvider>
  </Provider>,
  document.getElementById('root')
);
